import type { AutoOpsCardShared } from '@scale/genai-compass-shared/autoops/schema';
import {
  StepLabels,
  StepDescriptions,
  StepConfiguration,
} from '@scale/shared/types/ruleEngine/step';
import { CompassCardUI } from '@scale/compass-ui/types';
import { GenericAutoOpsContext } from '@scale/genai-compass-shared/autoops/cards';
import { Steps } from '@scale/shared/types/ruleEngine/stepList';
import preprocessInitialContext from './preprocessInitialContext';
import GenericAutoOpsComponent from './GenericAutoOpsComponent';
import { faCogs } from '@fortawesome/pro-solid-svg-icons';

export function makeAutoOpsCardUI<Shared extends AutoOpsCardShared>(
  shared: Shared,
  overrides: Partial<CompassCardUI>,
): CompassCardUI<Shared['schema'], GenericAutoOpsContext<Shared['cardType']>> {
  const defaultContext: GenericAutoOpsContext<Shared['cardType']> = {
    cardType: shared.cardType,
    step: Steps[shared.stepType] as StepConfiguration<Shared['stepType']>,
    hasProcessedStep: false,
  };

  return {
    ...shared,
    title: overrides.title || StepLabels[shared.stepType],
    icon: overrides.icon || 'cogs',
    toolTip: overrides.toolTip || StepDescriptions[shared.stepType],
    defaultContext,
    preprocessInitialContext,
    legacyComponent: GenericAutoOpsComponent,
    button: overrides.button || {
      icon: faCogs,
    },
    isLegacy: overrides.isLegacy,
  };
}
